import { FC } from "react";
import SmartSearchDateIntervalSelectAndActionsLayout from "../../../components/Layouts/smart-search-date-interval-select-and-actions-layout";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import {
  GetDailySalesDetailParams,
  getDailySalesDetail,
} from "../../../services/reports";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import {useAuth} from "../../../context/AuthProvider/useAuth";
//import dayjs from "../../../utils/timezone";
import {notificationError} from "../../../services/notification";
import dayjs from "dayjs";

const DailySalesDetail: FC = () => {
    const  affiliation  = useAuth().response?.affiliation
  return (
    <SmartSearchDateIntervalSelectAndActionsLayout
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      validOnEmpty
      onRefresh={(output, params, startDateInterval, endDateInterval):Promise<string | void> => {
        const getDailySalesDetailParams: GetDailySalesDetailParams = {
          output,
          beginDate: startDateInterval.format("MM/DD/YYYY"),
          endDate: endDateInterval.format("MM/DD/YYYY"),
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getDailySalesDetailParams[id] = params.id;
        }
        let display = true;
          if(affiliation === 'manufacturer' || affiliation === 'investigator') {
              if (dayjs(getDailySalesDetailParams.endDate).diff(dayjs(getDailySalesDetailParams.beginDate), 'days') > 365) {
                  notificationError('Date range cannot exceed 365 days')
                  display = false
              }
          }
          else {
              if (dayjs(getDailySalesDetailParams.endDate).diff(dayjs(getDailySalesDetailParams.beginDate), 'days') > 31) {
                  notificationError('Date range cannot exceed 31 days.  If multiple months are needed, please run individual months separately.')
                  display = false
              }
          }
        if (display)
            return getDailySalesDetail(getDailySalesDetailParams);
        else
            return Promise.resolve()
      }}
    />
  );
};

export default DailySalesDetail;
